
export const BASE_END_POINT = 'https://api-connect-stg.byitapp.com/api/v1/' 